module.exports = __webpack_public_path__ + "static/img/img-tuto-01.1faa943a.png";